import { lazy } from "react"

export const OrderHistoryPage = lazy(() => import("./OrderHistoryPage"))
